<template>
  <div>
        <label class="tag-check-item" v-for="item in computedItems" :key="item" :for="`input-${item}`"
               :style="{color: selected.includes(item) ? FreedomAppConfig.groupSelectedColor : FreedomAppConfig.groupColor}"
        >
            <input type="checkbox"  v-model="selected"  :value="item" :id="`input-${item}`">
            <span v-text="item"/>
        </label>
    <div class="button-wrapper" style="display: flex; justify-content: space-between">

    <button type="button" class="button primary"  @click="applyFilters(true)">Apply</button>
      <button type="button" class="button clear"  @click="applyFilters(false)">Close</button>
    </div>
  </div>

</template>

<script>
  import FreedomAppConfig from "../FreedomAppConfig";
  export default {
    name: "check-group",
    props: {
      items: {type: Array, required: true},
      value: {type: Array,  required: false},
      // selected: {type: Array, required: true},
    },
    data: function() {
      return {
        FreedomAppConfig,
        selected: []
      };
    },
    computed: {
      computedItems: function() {
        return this.items.map(i => i['value']);
        // this.selected.filter(x => !items.includes(x)).forEach(x => items.unshift(x));

      }
    },
    watch: {
      // selected: {
      //   deep: true,
      //   handler: function(selected) {
      //     this.$emit('input', selected);
      //   },
      // },
    },
    mounted: async function() {
      console.log(this.value);
      this.selected = this.value;
    },
    methods: {
      applyFilters: function(updateInput){
        if(updateInput) {
          this.$emit('input', this.selected);
        }
        console.log('checkgroup- apply filters');

        this.$emit('update', true );
      }
    }
  };
</script>

<style scoped>
.tag-check-item input {
  margin-bottom: 0;
}

.tag-check-item {
  margin-bottom: 1rem;
}
</style>